import { C_ACTION } from '../constans';

let new_state;
let index;

export const staff = (state = [], action) => {
  switch (action.type) {
    case C_ACTION.ADD_STAFF: {
      return [...action.data];
    }
    case C_ACTION.ADD_ONE_STAFF: {
      return [...state, action.user];
    }

    case C_ACTION.CHANGE_STAFF: {
      new_state = [...state];
      index = new_state.findIndex(item => item.login === action.login);

      console.log(index);
      new_state.splice(index, 1, action.user);
      return [...new_state];
    }

    default:
      return state;
  }
};
